import styled from "@emotion/styled";
import { Typography } from "@kaltura/ds-react-components";
import { NoResultsIllustration } from "@kaltura/mediaspace-shared-ui";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { KmsTypeComponent } from "@kaltura/mediaspace-shared-types";
import { ActionButtons } from "../action-buttons/ActionButtons";

const StyledNoSections = styled("div")({
    textAlign: "center",
});

const StyledActionButtons = styled(ActionButtons)(({ theme }) => ({
    marginTop: theme.spacing(3),
    justifyContent: "center",
    alignItems: "center",
}));

const StyledActionButtonsDescription = styled(Typography)(({ theme }) => ({
    marginTop: theme.spacing(2),
    color: theme.kaltura.palette.tone2,
}));

interface NoSectionsProps {
    actionButtonsDescription?: string;
    actionButtons?: KmsTypeComponent[];
}

/**
 * Category page - no sections
 */
export default function NoSections({ actionButtonsDescription, actionButtons }: NoSectionsProps) {
    return (
        <StyledNoSections>
            <NoResultsIllustration />
            <Typography component="h2" variant="h3">
                {translate("No content available yet")}
            </Typography>
            {actionButtonsDescription && (
                <StyledActionButtonsDescription variant={"body1"}>
                    {actionButtonsDescription}
                </StyledActionButtonsDescription>
            )}
            <StyledActionButtons actionButtons={actionButtons} isForEmptyState={true} />
        </StyledNoSections>
    );
}
